// @flow

import _ from 'lodash';
import { rem } from 'polished';
import React, { useState } from 'react';
import styled from 'styled-components';

import BREAKPOINTS from 'client/constants/styles/breakpoints';
import COLOR, { HEX_TRANSPARENT } from 'client/constants/colors';

import { getCountdownTimeString, pluralize } from 'client/components/countdownTimer';

type Props = {
  targetDate: string,
};

const ClockerWrapper = styled.div`
  color: ${COLOR.WHITE};
  display: inline-flex;
  width: 100%;
  align-items: center;
  padding: 1rem 0 1.5rem 0;
  @media screen and (max-width: ${BREAKPOINTS.MEDIUM}) {
    margin-top: 1rem;
  }
`;

const Column = styled.div`
  display: block;
  text-align: center;
  padding: 0.5rem;
`;

const NumberColumn = styled(Column)`
  background-color: ${`${COLOR.BLUE_2}${HEX_TRANSPARENT[67]}`};
  border-radius: ${rem(11)};
  width: 25%;
`;

const Number = styled.div`
  font-size: ${rem(40)};
  font-weight: bold;
  @media screen and (max-width: ${BREAKPOINTS.MEDIUM}) {
    font-size: ${rem(35)};
  }
`;

const Unit = styled.div`
  font-size: ${rem(14)};
  font-weight: bold;
`;

const Colon = styled.div`
  font-size: ${rem(24)};
  font-weight: bold;
`;

const CountdownClock = ({ targetDate }: Props) => {
  const initTimer = getCountdownTimeString({
    displayFullTime: true,
    targetDate: new Date(targetDate),
  });

  const [timerString, setTime] = useState(initTimer);

  setInterval(() => {
    setTime(
      getCountdownTimeString({
        displayFullTime: true,
        targetDate: new Date(targetDate),
      }),
    );
  }, 1000);

  const timer = timerString.split(':');
  const units = ['day', 'hour', 'min', 'sec'];

  if (timer.length === 1) {
    return (
      <ClockerWrapper>
        <Number>{timerString}</Number>
      </ClockerWrapper>
    );
  }

  return (
    <ClockerWrapper>
      {_.map(timer, (time: number, idx: string) => {
        const displayUnit = units[+idx];
        return (
          <React.Fragment key={displayUnit}>
            <NumberColumn>
              <Number>{time}</Number>
              <Unit>{pluralize(displayUnit, time)}</Unit>
            </NumberColumn>
            {displayUnit !== 'sec' && (
              <Column key={`${displayUnit}-colon`}>
                <Colon>:</Colon>
              </Column>
            )}
          </React.Fragment>
        );
      })}
    </ClockerWrapper>
  );
};

export default CountdownClock;
